import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchComponent } from './components/home/search/search.component';
import { WebScrapingComponent } from './components/web-scraping/web-scraping.component';
import { MapPageComponent } from './components/map-page/map-page.component';
import { AnalysisPageComponent } from './analysis-page/analysis-page.component';
import { AnalysisDisplayComponent } from './analysis-display/analysis-display.component';
import { SocialMediaPageComponent } from './components/social-media-page/social-media-page.component';
import { Ai_summaryComponent } from './components/home/ai_summary/ai_summary.component';
import { TestComponent } from './components/test/test.component';
import { EstateComponent } from './components/estate/estate.component';
import { ImportDictionaryComponent } from './components/import-dictionary/import-dictionary.component';
import { GeocodeComponent } from './components/geocode/geocode.component';

const routes: Routes = [
  {
    path:"home",
    loadChildren: () => import('./components/home/home.module').then((m) => m.HomeModule)
  },
  {
    path:"news",
    loadChildren: () => import('./components/news/news.module').then((m) => m.NewsModule)
  },
  {
    path:"nlp",
    loadChildren: () => import('./components/nlp/nlp.module').then((m) => m.NlpModule)
  },
  {
    path:"search",
    component: SearchComponent,
  },
  {
    path:"ai_summary",
    component: Ai_summaryComponent,
  },
  {
    path: "web-scraping",
    component: WebScrapingComponent,
  },
  {
    path:"import-dictionary",
    component: ImportDictionaryComponent
  },
  {
    path: "geocode",
    component: GeocodeComponent,
  },
  {
    path: "eatate",
    component: EstateComponent,
  },
  {
    path: "map",
    component: MapPageComponent
  },
  {
    path: "analysis",
    component: AnalysisPageComponent,
  },
  {
    path: "analysis-display",
    component: AnalysisDisplayComponent
  },
  {
    path: "social-media",
    component: SocialMediaPageComponent
  },
  {
    path: "test",
    component: TestComponent
  },
  {
    path: "**",
    redirectTo: 'home'
  },
];

  @NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
